import { jsx as I } from "react/jsx-runtime";
import { useState as k, useRef as d, useCallback as E, useMemo as P, useEffect as N } from "react";
import { SideNavContext as j } from "./context5.mjs";
import { useControlledState as w } from "./useControlledState.mjs";
import { isNotNil as g, isDefined as l } from "./types3.mjs";
import "./_root.mjs";
import "./_baseGetTag.mjs";
import { useMediaQuery as x } from "@mui/material";
import { MOBILE_SCREEN as G } from "./screens.mjs";
import { SIDE_NAV_LOCAL_STORAGE_KEY as Q } from "./constants28.mjs";
import { getLocalStorageValue as T, setLocalStorageValue as Y } from "./utils5.mjs";
const $ = ({
  isExpandedDefault: i = !0,
  canCollapseDefault: L = !i,
  expandOnHover: m = !0,
  hideCollapseButton: c,
  localStorageKey: p = Q,
  children: V,
  isExpanded: e,
  canCollapse: _,
  onExpandedChange: a
}) => {
  const n = x(
    (o) => o.breakpoints.down(G)
  ), r = T(p), b = g(r) ? r.isExpanded : i, M = g(r) ? r.canCollapse : L, [s, f] = w({
    defaultValue: b,
    value: e
  }), [t, u] = k(
    _ ?? M
  ), R = d(null), C = E(
    (o) => {
      l(e) || f(o), l(a) && a(o);
    },
    [e, a, f]
  ), v = E(
    (o) => {
      l(e) || u((D) => l(o) ? o : !D);
    },
    [e, u]
  ), S = d({
    toggleCollapse: v,
    toggleExpanded: C
  }), A = P(() => ({
    canCollapse: t,
    isExpanded: s,
    isMobile: n,
    api: S.current,
    sidebarRef: R,
    hideCollapseButton: c,
    expandOnHover: m
  }), [
    t,
    s,
    n,
    S.current,
    c,
    m
  ]);
  return N(() => {
    C(!t);
  }, [t]), N(() => {
    Y(p, { isExpanded: s, canCollapse: t });
  }, [s, t]), /* @__PURE__ */ I(j.Provider, { value: A, children: V });
};
export {
  $ as SideNavProvider
};
//# sourceMappingURL=index223.mjs.map
